// Generated by extract-enums.sh — do not edit manually

export enum ButtonTypeEnum {
  PRIMARY = "primary",

  OTHER_ACTION = "other_action",

  HIDDEN = "hidden",
}

export enum ContinuationTypeEnum {
  ONE_WAY = "one_way",

  ALL_WAY = "all_way",
}

export enum CooperatePartiesTypeEnum {
  GP = "gp",

  ORTHO = "ortho",

  OWNER = "owner",

  REFERRAL_RECIVIER = "referral_recivier",
}

export enum DependsOnOperatorEnum {
  AND = "and",

  OR = "or",
}

export enum SignalAutomaticTypeEnum {
  SEND_DM_APP_CODE = "send_dm_app_code",
  SEND_DM_LOGIN_LINK = "send_dm_login_link",
  SEND_PATIENT_DM = "send_patient_dm",

  START_PATIENT_MONITORING_DM = "start_patient_monitoring_dm",

  CREATE_NEW_PATIENT_TREATMENT_PLAN = "create_new_patient_treatment_plan",

  SEND_PATIENT_TO_ORTHO_REFERRAL = "send_patient_to_ortho_referral",

  START_TREATMENT_PLAN = "start_treatment_plan",

  SEND_PATIENT_C9 = "send_patient_c9",
}

export enum SignalManualTypeEnum {
  ONLY_ORTHODONTIC_TREATMENT = "only_orthodontic_treatment",

  FINANCING_PLAN_CREATED = "financing_plan_created",

  CONTRACT_CREATED = "contract_created",
}

export enum SignalRecurringTypeEnum {
  PATIENT_MONITORING_START = "patient_monitoring_start",
}

export enum SignalSystemTypeEnum {
  PATIENT_CREATED = "patient_created",
  PATIENT_CREATED_UNVERIFIED = "patient_created_unverified",
  PATIENT_RECORDS_CREATED = "patient_records_created",

  ORTHO_NEEDS_CREATED = "ortho_needs_created",
  ORTHO_NEEDS_CONFIRMED = "ortho_needs_confirmed",
  ORTHO_NEEDS_APPROVED = "ortho_needs_approved",
  ORTHO_PROPOSED_PLAN_CREATED = "ortho_proposed_plan_created",
  ORTHO_PROPOSED_PLAN_CONFIRMED = "ortho_proposed_plan_confirmed",
  ORTHO_PROPOSED_PLAN_SIGNED = "ortho_proposed_plan_signed",

  INSTRUCTIONS_FOR_NEXT_VISIT_CREATED = "instructions_for_next_visit_created",
  INSTRUCTIONS_FOR_NEXT_VISIT_CONFIRMED = "instructions_for_next_visit_confirmed",
  INSTRUCTIONS_FOR_NEXT_VISIT_COMPLETED = "instructions_for_next_visit_completed",

  PATIENT_LINKED_TO_ORTHO = "patient_linked_to_ortho",
  PATIENT_LINKED_TO_GP = "patient_linked_to_gp",
  PATIENT_LINKED_TO_TC = "patient_linked_to_tc",
  PATIENT_FINANCING_PLAN_CREATED = "patient_financing_plan_created",

  ORDER_ALIGNERS_CREATED = "order_aligners_created",
  ORDER_ALIGNERS_ARRIVED = "order_aligners_arrived",
  ORDER_ALIGNERS_APPLIED = "order_aligners_applied",

  SCHEDULE_TC_APPOINTMENT_CREATED = "schedule_tc_appointment_created",
  SCHEDULE_TC_APPOINTMENT_DONE = "schedule_tc_appointment_done",

  SCANBOX_HANDOVER = "scanbox_handover",

  PATIENT_CONFIRMED = "patient_confirmed",

  ALIGNER_DELIVERY_INSTRUCTIONS_CREATED = "aligner_delivery_instructions_created",
  ALIGNER_DELIVERY_INSTRUCTIONS_CONFIRMED = "aligner_delivery_instructions_confirmed",
  ALIGNER_DELIVERY_INSTRUCTIONS_COMPLETED = "aligner_delivery_instructions_completed",
  ALIGNER_DELIVERY_INSTRUCTIONS_SENT_RESULT = "aligner_delivery_instructions_sent_result",

  NEXT_VISIT_INSTRUCTIONS_V2_CREATED = "next_visit_instructions_v2_created",
  NEXT_VISIT_INSTRUCTIONS_V2_CONFIRMED = "next_visit_instructions_v2_confirmed",
  NEXT_VISIT_INSTRUCTIONS_V2_COMPLETED = "next_visit_instructions_v2_completed",
  NEXT_VISIT_INSTRUCTIONS_V2_SENT_RESULT = "next_visit_instructions_v2_sent_result",

  FINAL_DEBOND_VISIT_INSTRUCTIONS_CREATED = "final_debond_visit_instructions_created",
  FINAL_DEBOND_VISIT_INSTRUCTIONS_CONFIRMED = "final_debond_visit_instructions_confirmed",
  FINAL_DEBOND_VISIT_INSTRUCTIONS_COMPLETED = "final_debond_visit_instructions_completed",
  FINAL_DEBOND_VISIT_INSTRUCTIONS_SENT_RESULT = "final_debond_visit_instructions_sent_result",

  PATIENT_LINKED_TO_GP_PRACTICE = "patient_linked_to_gp_practice",
  PATIENT_LINKED_TO_ORTHO_PRACTICE = "patient_linked_to_ortho_practice",

  REFERRAL_CREATED = "referral_created",
  REFERRAL_ACCEPTED = "referral_accepted",
  REFERRAL_REJECTED = "referral_rejected",
  REFERRAL_APPOINTMENT_CREATED = "referral_appointment_created",
  REFERRAL_APPOINTMENT_DONE = "referral_appointment_done",
  REFERRAL_STATUS_UPDATE = "referral_status_update",

  SELECT_TREATMENT = "select_treatment",

  REQUEST_ITERO_SCAN = "request_itero_scan",

  ADD_COOPERATE_ORTHO = "add_cooperate_ortho",
  ADD_COOPERATE_GP = "add_cooperate_gp",
  ADD_COOPERATE_TC = "add_cooperate_tc",

  SEND_DM_LOGIN_LINK = "send_dm_login_link",

  REFERRAL_PAID_PROPOSAL_PRICE_CREATED = "referral_paid_proposal_price_created",

  ARCHIVE = "archive",
}

export enum SignalTypeEnum {
  MANUAL = "manual",

  SYSTEM = "system",

  AUTOMATIC = "automatic",

  RECURRING = "recurring",

  UI_CONTROL = "ui_control",
}

export enum SignalUiControlTypeEnum {
  SHOW_DM_WIDGET = "show_dm_widget",
  SHOW_REFERRAL_STATUS_WIDGET = "show_referral_status_widget",
}

export enum TreatmentJobStateEnum {
  PENDING = "pending",

  IN_PROGRESS = "in_progress",

  COMPLETED = "completed",

  FAILED = "failed",

  EXCLUDED = "excluded",
}
